import {ApiRoute} from '~/constants/api';
import store from '~/redux/store';
import axiosInstance from '~/services/api/axios';

export interface IRefundPaymentVariables {
  payment_id: number;
  amount: string;
  reason: string;
  notes: string;
}

export interface RefundDetails {
  id: number;
  amount: string;
  reason: string;
  other_reason: string | null;
  notes: string;
  status: string;
}

export interface RefundPaymentResponse {
  success: boolean;
  data: {
    payment: {
      id: number;
      amount: string;
      patient_id: string;
      status: string;
      payment_method: string;
      patient_full_name: string;
      invoice_number: string;
      description: string;
      billing_date: string;
      refund_details: RefundDetails;
    };
  };
  message: string;
}

export async function postRefundPayment(
  variables: IRefundPaymentVariables
): Promise<RefundPaymentResponse> {
  const state = store.getState();
  const token = state.auth.token;
  const {payment_id, amount, reason, notes} = variables;

  const response = await axiosInstance.post(
    ApiRoute.Refund,
    {
      refund: {
        payment_id,
        amount,
        reason,
        notes,
      },
    },
    {
      headers: {
        Authorization: token,
      },
    }
  );

  return response.data;
}
